import { ICoreDataEntity } from '@barthauer/abc/core/data';

export class AdditionalMenuItem {
  //The name have to change
  deny?: boolean;
  disabled: boolean;
  icon: string;
  key?: string;
  name: string;
  subCollectionName?: string;
  onClick: (dataEntity: ICoreDataEntity) => void;
  readOnly?: boolean;
  tooltip: string;
  visibleIndex?: number;
  beginGroup?: boolean;
}
